<template>
  <div>
    <v-text-field
        v-model="password"
        color="secondary"
        :label="$t('global.password')"
        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        :rules="rules.password"
        :type="show ? 'text' : 'password'"
        name="password"
        :hint="$t('register.min-password-security')"
        @click:append="show = !show"
      />

      <v-expand-transition>
      <v-text-field
        v-show="isPasswordValid"
        id="confirmPassword"
        v-model="confirmPassword"
        color="secondary"
        :label="$t('register.confirm-password')"
        :append-icon="showConfirmEye ? 'mdi-eye' : 'mdi-eye-off'"
        :rules="[ matchPassword ]"
        :type="showConfirmEye ? 'text' : 'password'"
        name="confirmPassword"
        @click:append="showConfirmEye = !showConfirmEye"
      />
      </v-expand-transition>
  </div>
</template>

<script>
  import zxcvbn from 'zxcvbn'

  export default ({
    name: 'PasswordSetFields',

    data: () => ({
      password: '',
      confirmPassword: '',
      show: false,
      showConfirmEye: false,
    }),

    computed: {
      rules () {
        return {
          password: [
            v => !!v || this.$t('password-set.password-is-required'),
            v => v.length >= 8 || this.$t('password-set.password-length'),
            v => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d@$£!._%*?&]{8,}$/.test(v) || this.$t('password-set.password-complexity'),
            value => !!value || this.$i18n.t('login.required'),
            value => {
              const passwordAnalysis = zxcvbn(value)
              return passwordAnalysis.score > 2 || this.$t('register.password-is-weak')
            },
          ],
        }
      },

      matchPassword () {
        return this.confirmPassword === this.password || this.$t('password-set.passwords-do-not-match')
      },
      isPasswordValid () {
        return this.rules.password.every(rule => rule(this.password) === true)
      },

    },

    watch: {
      password (newVal, oldVal) {
        if (this.isPasswordValid) {
          this.onPasswordChange(newVal)
        }
      },
    },

    methods: {
      onPasswordChange (newVal) {
        this.$emit('password-change', this.password)
      },
    },
  })
</script>
